 const Hamster_DAO_LPADDR = '0x169c88d9245528C3c0e2814aF566CA56cCE8A16e'

 const Hamster_DAO_PLEDGE_ADDR = '0x115C5DD3cD6A488dE74e7bBd3AF62E45E6B7B4c9'

 export  { Hamster_DAO_LPADDR, Hamster_DAO_PLEDGE_ADDR }